/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Language } from './Language';
import {
	LanguageFromJSON,
	LanguageFromJSONTyped,
	LanguageToJSON,
	LanguageToJSONTyped,
} from './Language';
import type { EasyClaimAppState } from './EasyClaimAppState';
import {
	EasyClaimAppStateFromJSON,
	EasyClaimAppStateFromJSONTyped,
	EasyClaimAppStateToJSON,
	EasyClaimAppStateToJSONTyped,
} from './EasyClaimAppState';

/**
 *
 * @export
 * @interface CaseUpdateControlCommandParams
 */
export interface CaseUpdateControlCommandParams {
	/**
	 *
	 * @type {string}
	 * @memberof CaseUpdateControlCommandParams
	 */
	caseId?: string;
	/**
	 *
	 * @type {EasyClaimAppState}
	 * @memberof CaseUpdateControlCommandParams
	 */
	screenId?: EasyClaimAppState;
	/**
	 *
	 * @type {string}
	 * @memberof CaseUpdateControlCommandParams
	 */
	controlId?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof CaseUpdateControlCommandParams
	 */
	value?: string | null;
	/**
	 *
	 * @type {Language}
	 * @memberof CaseUpdateControlCommandParams
	 */
	language?: Language;
}

/**
 * Check if a given object implements the CaseUpdateControlCommandParams interface.
 */
export function instanceOfCaseUpdateControlCommandParams(
	value: object
): value is CaseUpdateControlCommandParams {
	return true;
}

export function CaseUpdateControlCommandParamsFromJSON(json: any): CaseUpdateControlCommandParams {
	return CaseUpdateControlCommandParamsFromJSONTyped(json, false);
}

export function CaseUpdateControlCommandParamsFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): CaseUpdateControlCommandParams {
	if (json == null) {
		return json;
	}
	return {
		caseId: json['caseId'] == null ? undefined : json['caseId'],
		screenId: json['screenId'] == null ? undefined : EasyClaimAppStateFromJSON(json['screenId']),
		controlId: json['controlId'] == null ? undefined : json['controlId'],
		value: json['value'] == null ? undefined : json['value'],
		language: json['language'] == null ? undefined : LanguageFromJSON(json['language']),
	};
}

export function CaseUpdateControlCommandParamsToJSON(json: any): CaseUpdateControlCommandParams {
	return CaseUpdateControlCommandParamsToJSONTyped(json, false);
}

export function CaseUpdateControlCommandParamsToJSONTyped(
	value?: CaseUpdateControlCommandParams | null,
	ignoreDiscriminator: boolean = false
): any {
	if (value == null) {
		return value;
	}

	return {
		caseId: value['caseId'],
		screenId: EasyClaimAppStateToJSON(value['screenId']),
		controlId: value['controlId'],
		value: value['value'],
		language: LanguageToJSON(value['language']),
	};
}
